// eslint-disable-next-line import/prefer-default-export
export function updateDefaultOfficeFacility(facilityId: string) {
  sessionStorage.setItem('facilityId', facilityId);
}
